module.exports = __webpack_public_path__ + "static/008612-8a3e6102b2232aa39497c3e1c3c3ae11.jpg";